import React from "react"
import ActiveLine from "./ActiveLine"
import ActiveMarker from "./ActiveMarker"

export default function ActiveFeatureView({ activeFeature, allLines, allMarks, onArchiveLine, onArchiveMark }) {
  if (!activeFeature) {
    return null
  }

  // Determine if the active feature is a line or marker
  const line = allLines?.find(l => l.id === activeFeature)
  const marker = allMarks?.find(m => m.id === activeFeature)

  if (line) {
    return <ActiveLine line={line} onArchive={() => onArchiveLine(activeFeature)} />
  } else if (marker) {
    return <ActiveMarker marker={marker} onArchive={() => onArchiveMark(activeFeature)} />
  }

  return null
}
